import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const CompetitionResult = () => {
  return (
    <React.Fragment>
      <SEO title="ICSI-OC'2022 | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="ICSI-OC'2022 Result"
        content="For Authors"
        contentTwo="ICSI-OC'2022 Result"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h2>
            The FINAL Results of ICSI Optimization Competition 2022
            (ICSI-OC&apos;2022)
          </h2>
          <br></br>
          <br></br>
          <br></br>
          <h3 id="competition1">
            ICSI-OC&apos;2022:{" "}
            <em>
              Competition on Single Objective Bounded Optimization Problems
            </em>
          </h3>
          <br></br>
          <br></br>
          <h4>Overview</h4>
          <p>
            ICSI Optimization Competition (ICSI-OC) is a series of
            algorithm competition held by ICSI. ICSI-OC provides dedicated test
            sets and competitions for researchers to test their swarm
            intelligence algorithms and evolutionary algorithms.<br></br>
            <br></br>
            ICSI-OC &apos;2022 is the first algorithm competition of ICSI-OC. It
            launched{" "}
            <em>
              Competition on Single Objective Bounded Optimization Problems.
            </em>
            {/* Since optimization problems are widely used in real-world
            applications, it has always been one of the hot topics in research.
            With the popularity of machine learning and deep learning, how to
            efficiently and accurately solve optimization problems has become an
            urgent problem that needs to be addressed. Among them, the
            single-objective bounded optimization problem is one of the basic
            types of all optimization problems. Due to the complexity of modern
            optimization problems, the optimization of some complex functions is
            relatively difficult. Decades ago, the emergence of stochastic
            search algorithms such as evolutionary algorithms and swarm
            intelligence algorithms makes it possible to find the global optimal
            solutions of some complex functions. In order to test the
            performance of numerous evolutionary algorithms and swarm
            intelligence algorithms, we propose a test set to complete this
            task. */}
            &nbsp; This competition is devoted to the evolutionary algorithms
            and swarm intelligence algorithms for solving single-objective
            bounded optimization. We encourage all researchers to test their
            algorithms on the ICSI&apos;2022 test set. This test set includes 10
            black-box test functions which means you do not need to know the
            exact form of these test functions. This form of benchmark functions
            is convenient for researchers to design and improve their
            algorithms, and it is also helpful for improving the generalization
            of the algorithms.
            <br />
          </p>
          <div className="space-20"></div>
          <h4>Evaluation Criteria</h4>
          <br></br>
          All submitted papers and experimental results will be judged by the
          Organizing Committee using the same criteria. Ranking is mainly based
          on the average value of the results. We will use the Wilcoxon rank sum
          test on all experimental results to examine the differences between
          the different algorithms. The average ranking for each algorithm is
          then calculated. If the ranking is the same, then the time complexity
          of the algorithm and the resource occupied are also taken into
          account.
          <div className="space-60"></div>
          <h4>Result</h4>
          <br></br>
          <br></br>
          <div className="title-center">
            <h5> Mean Rank for All Algorithms</h5>
          </div>
          <div className="fun-10d">
            <table className="dataframe">
              <thead>
                <tr>
                  <th width={300}>Algorithms</th>
                  <th>F1</th>
                  <th>F2</th>
                  <th>F3</th>
                  <th>F4</th>
                  <th>F5</th>
                  <th>F6</th>
                  <th>F7</th>
                  <th>F8</th>
                  <th>F9</th>
                  <th>F10</th>
                  <th>Mean</th>
                  <th>Rank</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>
                    Differential Evolution with Biased Parameter Adaptation
                  </th>
                  <td>2.33</td>
                  <td>3.33</td>
                  <td>3.00</td>
                  <td>3.00</td>
                  <td>4.00</td>
                  <td>3.00</td>
                  <td>3.00</td>
                  <td>5.67</td>
                  <td>5.33</td>
                  <td>3.67</td>
                  <td>3.63</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>Deep-Layered Differential Evolution</th>
                  <td>2.67</td>
                  <td>2.33</td>
                  <td>1.33</td>
                  <td>2.00</td>
                  <td>2.33</td>
                  <td>2.67</td>
                  <td>2.00</td>
                  <td>3.67</td>
                  <td>3.67</td>
                  <td>3.00</td>
                  <td>2.57</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>Group Simulated Annealing Algorithm</th>
                  <td>4.00</td>
                  <td>3.67</td>
                  <td>5.33</td>
                  <td>6.00</td>
                  <td>3.67</td>
                  <td>6.00</td>
                  <td>6.00</td>
                  <td>5.33</td>
                  <td>5.00</td>
                  <td>4.67</td>
                  <td>4.96</td>
                  <td>6</td>
                </tr>
                <tr>
                  <th>
                    Composite Evolutionary Strategy and Differential Evolution
                    Method
                  </th>
                  <td>5.67</td>
                  <td>6.00</td>
                  <td>5.67</td>
                  <td>5.00</td>
                  <td>4.33</td>
                  <td>3.33</td>
                  <td>5.00</td>
                  <td>1.33</td>
                  <td>1.67</td>
                  <td>4.33</td>
                  <td>4.23</td>
                  <td>4</td>
                </tr>
                <tr>
                  <th>
                    Surrogate-assisted Differential Evolution-based Method
                  </th>
                  <td>5.33</td>
                  <td>4.67</td>
                  <td>4.00</td>
                  <td>4.00</td>
                  <td>5.67</td>
                  <td>5.00</td>
                  <td>4.00</td>
                  <td>2.83</td>
                  <td>4.00</td>
                  <td>4.33</td>
                  <td>4.38</td>
                  <td>5</td>
                </tr>
                <tr>
                  <th>Fireworks Algorithm with Search Space Partition</th>
                  <td>1.00</td>
                  <td>1.00</td>
                  <td>1.67</td>
                  <td>1.00</td>
                  <td>1.00</td>
                  <td>1.00</td>
                  <td>1.00</td>
                  <td>2.17</td>
                  <td>1.33</td>
                  <td>1.00</td>
                  <td>1.22</td>
                  <td>1</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="space-60"></div>
          <div className="title-center">
            <h4> The Top Three Algorithms</h4>
            <br></br>
          </div>
          <div className="rank1">
            The First Place: Fireworks Algorithm with Search Space Partition
          </div>
          <div className="crucial2">
            <span className="font-black">Competitors: &nbsp;</span>
            Yifan Liu, Yifeng Li, and Ying Tan
            <br></br>
            <span className="font-black">Affiliate: &nbsp;</span>
            Key laboratory of Machine Perception (MOE), School of Artificial
            Intelligence, Institute for Artificial Intelligence, Peking
            University, Beijing 100871, China
            <br></br>
            <span className="font-black"> Paper: &nbsp;</span> No.9626
          </div>
          <div className="space-40"></div>
          <div className="rank2">The Second place: Deep-Layered Differential Evolution</div>
          <div className="crucial2">
            <span className="font-black">Competitors: &nbsp;</span>
            Kaiyu Wang, Zhenyu Lei, Ziqian Wang, Zhiming Zhang, and Shangce Gao
            <br></br>
            <span className="font-black">Affiliate: &nbsp;</span>
            Faculty of Engineering, University of Toyama, Toyama, Japan
            <br></br>
            <span className="font-black"> Paper:&nbsp;</span>             No.5593
          </div>
          <div className="space-40"></div>
          <div className="rank3">The Third place: Differential Evolution with Biased Parameter Adaptation</div>
          <div className="crucial2">
            <span className="font-black">Competitors: &nbsp;</span>
            Vladimir Stanovov, and Shakhnaz Akhmedova<br></br>
            <span className="font-black">Affiliate: &nbsp;</span>
            Reshetnev Siberian State University of Science and Technology,
            Institute of Informatics and Telecommunication, Krasnoyarsk, 660037,
            Russia
            <br></br>
            <span className="font-black"> Paper:&nbsp;</span>
            No. 377
          </div>
          <div className="space-60"></div>
          <div className="space-60"></div>
          <h4>Rank for Each Dimension Problems </h4>
          <div className="space-40"></div>
          <div className="title-center">
            <h5> Rank for 10D Problems</h5>
          </div>
          <div className="fun-10d">
            <table className="dataframe">
              <thead>
                <tr>
                  <th width={300}>Algorithms</th>
                  <th>F1</th>
                  <th>F2</th>
                  <th>F3</th>
                  <th>F4</th>
                  <th>F5</th>
                  <th>F6</th>
                  <th>F7</th>
                  <th>F8</th>
                  <th>F9</th>
                  <th>F10</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Differential Evolution with Biased Parameter Adaptation</th>
                  <td>2.0</td>
                  <td>4.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>4.0</td>
                  <td>3.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                </tr>
                <tr>
                  <th>Deep-Layered Differential Evolution</th>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>1.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                </tr>
                <tr>
                  <th>Group Simulated Annealing Algorithm</th>
                  <td>4.0</td>
                  <td>3.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>4.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>5.0</td>
                </tr>
                <tr>
                  <th>Composite Evolutionary Strategy and Differential Evolution Method</th>
                  <td>5.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>6.0</td>
                  <td>2.0</td>
                  <td>5.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                </tr>
                <tr>
                  <th>Surrogate-assisted Differential Evolution-based Method</th>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                </tr>
                <tr>
                  <th>Fireworks Algorithm with Search Space Partition</th>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>2.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="space-60"></div>
          <div className="title-center">
            <h5> Rank for 20D Problems</h5>
          </div>
          <div className="fun-10d">
            <table className="dataframe">
              <thead>
                <tr>
                  <th width={300}>Algorithms</th>
                  <th>F1</th>
                  <th>F2</th>
                  <th>F3</th>
                  <th>F4</th>
                  <th>F5</th>
                  <th>F6</th>
                  <th>F7</th>
                  <th>F8</th>
                  <th>F9</th>
                  <th>F10</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Differential Evolution with Biased Parameter Adaptation</th>
                  <td>2.0</td>
                  <td>4.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>4.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>4.0</td>
                </tr>
                <tr>
                  <th>Deep-Layered Differential Evolution</th>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>1.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>2.0</td>
                </tr>
                <tr>
                  <th>Group Simulated Annealing Algorithm</th>
                  <td>4.0</td>
                  <td>3.0</td>
                  <td>5.0</td>
                  <td>6.0</td>
                  <td>3.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>3.0</td>
                </tr>
                <tr>
                  <th>Composite Evolutionary Strategy and Differential Evolution Method</th>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>5.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>6.0</td>
                </tr>
                <tr>
                  <th>Surrogate-assisted Differential Evolution-based Method</th>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>5.0</td>
                </tr>
                <tr>
                  <th>Fireworks Algorithm with Search Space Partition</th>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>2.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>1.0</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="space-60"></div>
          <div className="title-center">
            <h5> Rank for 50D Problems</h5>
          </div>
          <div className="fun-10d">
            <table className="dataframe">
              <thead>
                <tr>
                  <th width={300}>Algorithms</th>
                  <th>F1</th>
                  <th>F2</th>
                  <th>F3</th>
                  <th>F4</th>
                  <th>F5</th>
                  <th>F6</th>
                  <th>F7</th>
                  <th>F8</th>
                  <th>F9</th>
                  <th>F10</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Differential Evolution with Biased Parameter Adaptation</th>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>5.0</td>
                  <td>3.0</td>
                  <td>3.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>3.0</td>
                </tr>
                <tr>
                  <th>Deep-Layered Differential Evolution</th>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                  <td>3.0</td>
                  <td>2.0</td>
                  <td>2.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                </tr>
                <tr>
                  <th>Group Simulated Annealing Algorithm</th>
                  <td>4.0</td>
                  <td>5.0</td>
                  <td>5.0</td>
                  <td>6.0</td>
                  <td>4.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                </tr>
                <tr>
                  <th>Composite Evolutionary Strategy and Differential Evolution Method</th>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>2.0</td>
                  <td>4.0</td>
                  <td>5.0</td>
                  <td>1.0</td>
                  <td>2.0</td>
                  <td>5.0</td>
                </tr>
                <tr>
                  <th>Surrogate-assisted Differential Evolution-based Method</th>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>4.0</td>
                  <td>6.0</td>
                  <td>5.0</td>
                  <td>4.0</td>
                  <td>2.5</td>
                  <td>3.0</td>
                  <td>2.0</td>
                </tr>
                <tr>
                  <th>Fireworks Algorithm with Search Space Partition</th>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>1.0</td>
                  <td>2.5</td>
                  <td>1.0</td>
                  <td>1.0</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default CompetitionResult;
